export enum TeamsRoutes {
  root = 'organization/teams',
  create = 'create',
  manage = 'manage/:teamId',
}
